import { Component } from '@angular/core';
import { ReactPageComponent } from 'common';
import { ReportListPage } from './reportlist/reportList';

@Component({
  selector: 'app-page-businessintelligence',
  template: '<div class="react-page" #container></div>'
})
export class PageBusinessIntelligenceComponent extends ReactPageComponent {
  get Component(){
    return ReportListPage;
  }
}
